"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_NODE = void 0;
exports.IS_NODE = typeof document === 'undefined';
